export const DEFAULT_PAGE = 0;
export const DEFAULT_ROWS_PER_PAGE = 20;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_CHANNEL_PRODUCTS_PER_PAGE = 100;
